import React, { useState, useEffect } from "react";
import Button from "../buttons/button";

const TableFilter = ({ title, buttonTitle, onClick, onSearch,subTitle }) => {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearch(searchTerm);
    }, 400); // delay to reduce calls

    return () => clearTimeout(timeout);
  }, [searchTerm]);

  return (
    <div className="filter_head d-flex gap-2 align-items-center justify-content-between mb-3">
     <div className="flex-grow-1">
       <h3 className=" mb-0 cmn_heading">{title}</h3>
      <p>{subTitle}</p>
     </div>
      <div className="search-from">
        <input
        className="form-control"
        type="search"
        placeholder="Search ..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      </div>
      {buttonTitle && <Button onClick={onClick} size="small" label={buttonTitle} />}
    </div>
  );
};

export default TableFilter;
